/*****************************************************************
 * HeaderAccountBlock
 * Renders the account section in the header, with portrait-specific
 * layout: icons (notification + PWA) on the left, name/button on the right.
 * Desktop keeps the original order: name, logout, icons.
 * ***************************************************************/

import NotificationBell from 'Ui/Components/Notification/NotificationBell'
import PwaInstallPrompt from 'Ui/Components/Pwa/PwaInstallPrompt'
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

export const HeaderAccountBlock = ({
    isPortrait,
    isMobile,
    isUserConnected,
    shouldShowNotification,
    shouldShowPwa,
    shouldShowDashboardLink,
    displayFirstName,
    displayUserName,
    connectionButtonLabel,
    connectionHandler,
}) => {
    const isPortraitMobile = isPortrait && isMobile

    /* ---- Connected ---- */
    if (isUserConnected && shouldShowDashboardLink) {
        if (isMobile) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    {isPortraitMobile && shouldShowNotification && (
                        <NotificationBell isAuthenticated={true} />
                    )}
                    {isPortraitMobile && shouldShowPwa && <PwaInstallPrompt />}
                    <a
                        className="header-link"
                        href="/dashboard"
                        style={isPortraitMobile ? { marginLeft: 'auto' } : { marginRight: '10px' }}
                    >
                        <span>{displayFirstName}</span>
                    </a>
                    {!isPortraitMobile && shouldShowNotification && (
                        <NotificationBell isAuthenticated={true} />
                    )}
                    {!isPortraitMobile && shouldShowPwa && <PwaInstallPrompt />}
                </div>
            )
        }

        /* Desktop connected */
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <a className="header-link" href="/dashboard">
                    <span>{displayUserName}</span>
                </a>
                <button className="header-btn" onClick={connectionHandler}>
                    {ihm_viewer__dictionary.LOGIN.LOGOUT[locale()]}
                </button>
                {shouldShowNotification && <NotificationBell isAuthenticated={true} />}
                {shouldShowPwa && <PwaInstallPrompt />}
            </div>
        )
    }

    /* ---- Not connected ---- */
    if (!isUserConnected) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                {isPortraitMobile && shouldShowNotification && (
                    <NotificationBell isAuthenticated={false} onLoginRequest={connectionHandler} />
                )}
                {isPortraitMobile && shouldShowPwa && <PwaInstallPrompt />}
                <button
                    className="header-btn"
                    onClick={connectionHandler}
                    style={isPortraitMobile ? { marginLeft: 'auto' } : undefined}
                >
                    {connectionButtonLabel}
                </button>
                {!isPortraitMobile && shouldShowNotification && (
                    <NotificationBell isAuthenticated={false} onLoginRequest={connectionHandler} />
                )}
                {!isPortraitMobile && shouldShowPwa && <PwaInstallPrompt />}
            </div>
        )
    }

    return null
}
